var classes = {"modalRoot":"zPoVv","modalOverlay":"yofGP","modal":"Ofhw4","modalContentWrapper":"PrKKC","modalCloseIcon":"R9Ygy"};

export { classes as default };
